import { render, staticRenderFns } from "./EstateCostsCard.vue?vue&type=template&id=44740b10&scoped=true"
import script from "./EstateCostsCard.vue?vue&type=script&lang=js"
export * from "./EstateCostsCard.vue?vue&type=script&lang=js"
import style0 from "./EstateCostsCard.vue?vue&type=style&index=0&id=44740b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44740b10",
  null
  
)

export default component.exports